
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/decks/[commander]",
      function () {
        return require("private-next-pages/decks/[commander]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/decks/[commander]"])
      });
    }
  